import { createActions } from 'redux-actions';

const actions = createActions({
  GET_FEATURE_FLAGS: () => { },
  GET_FEATURE_FLAGS_FAILED: (data) => data,
  GET_FEATURE_FLAGS_LOADED: (data) => data,
  ZIP_CODE_DETAILS_LOADED: (data) => (data),
});

export const {
  getFeatureFlags,
  getFeatureFlagsFailed,
  getFeatureFlagsLoaded,
  zipCodeDetailsLoaded,
} = actions;
